<svg
  width="33"
  height="33"
  viewBox="0 0 33 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_2053_1455)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.3193 0.508796L31.1036 0.153787C31.9942 0.0702407 32.4395 0.0284674 32.7054 0.294413C32.9713 0.560359 32.9296 1.00565 32.846 1.89623L32.491 5.68054C32.3534 7.14714 32.2846 7.88044 31.8068 8.05265C31.329 8.22486 30.8082 7.70407 29.7666 6.66248L28.6707 5.56654L28.4705 5.76672L26.8795 7.35771L24.2279 10.0094L22.6369 11.6003L1.49787 32.7394C1.15616 33.0811 0.602141 33.0811 0.260432 32.7394C-0.0812768 32.3977 -0.0812768 31.8437 0.260432 31.502L21.3976 10.3648C21.3982 10.3642 21.3988 10.3636 21.3995 10.3629L22.9905 8.77192C22.9911 8.77129 22.9917 8.77065 22.9924 8.77002L25.6404 6.12201C25.6409 6.12143 25.6415 6.12085 25.6421 6.12027L27.2331 4.52928C27.2337 4.5287 27.2343 4.52813 27.2348 4.52755L27.4333 4.32911L26.3373 3.23317C25.2958 2.19158 24.775 1.67078 24.9472 1.19298C25.1194 0.71517 25.8527 0.646379 27.3193 0.508796Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2053_1455">
      <rect
        width="33"
        height="33"
        fill="white"
        transform="translate(-0.000244141)"
      />
    </clipPath>
  </defs>
</svg>
